import axios from 'axios';
import { loginRequest, loginRequestApi, getMsalConfig } from 'connection/AuthConfig';
import { HttpConstants } from 'constants/HttpConstants';
import { PublicClientApplication } from '@azure/msal-browser';
import { getAccessToken } from 'services/AzureLoginService';

const jwt = require('jsonwebtoken');

const verifyTokenExpiration = (accessToken: string) : boolean => {
  if(accessToken){
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const decodedToken = jwt.decode(accessToken, { complete: true });
    if (decodedToken.payload.exp && decodedToken.payload.exp < currentTimeInSeconds) {
      return true;
    }
  }
  return false;
}

const initializeMsal = async () => {
  const config = await getMsalConfig();
  return new PublicClientApplication(config);
}
  
const getStorageToken = () => {
  if (typeof(Storage) !== 'undefined') {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes('msal.token.keys')) {
        const msalTokenKeys = localStorage.getItem(key);
        const token = localStorage.getItem(JSON.parse(msalTokenKeys).accessToken[0])
        return JSON.parse(token).secret;
      }
    }
  }
}

const getToken = async (scopeType = 'default') => {
  const publicClientApp = await initializeMsal();
  if (scopeType === 'api')
  {
    const account = publicClientApp.getAllAccounts()[0];
    return getAccessToken(publicClientApp, account, loginRequestApi);
  }
  else
  {
    const token = getStorageToken();
    if(verifyTokenExpiration(token)){
      const account = publicClientApp.getAllAccounts()[0];
      return getAccessToken(publicClientApp, account, loginRequest);
    }
    return token;
  }
};

const cerberusApi = axios.create({ baseURL: '' });

cerberusApi.interceptors.request.use(async (config) => {
  const useApiManagement = config.headers && config.headers['X-Use-Api-Management'] === 'true';
  const scopeType = useApiManagement ? 'api' : 'default';
  const accessToken = await getToken(scopeType);
  config.headers[HttpConstants.HEADER_CONTENT] = HttpConstants.TYPE_JSON;
  config.headers[HttpConstants.AUTHORIZATION] = `Bearer ${accessToken}`;
  
  delete config.headers['X-Use-Api-Management'];
  return config;
});

export default cerberusApi;